export default "__VITE_PUBLIC_ASSET__c490d4f1__"